var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReports = function SvgReports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M13 14a2 2 0 0 0-2 2v8h37a2 2 0 0 1 2 2v27h7a2 2 0 0 0 2-2V16a2 2 0 0 0-2-2z",
    clipRule: "evenodd",
    opacity: 0.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF9D43",
    fillRule: "evenodd",
    d: "M22 4a2 2 0 0 0-2 2v18h28a2 2 0 0 1 2 2v17h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z",
    clipRule: "evenodd",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F68D1",
    fillRule: "evenodd",
    d: "M4 24a2 2 0 0 0-2 2v35a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V26a2 2 0 0 0-2-2zm20.277 9.865a9.5 9.5 0 1 1-17.554 7.27 9.5 9.5 0 0 1 17.554-7.27M17 56a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm-9 0a2 2 0 1 0 0 4h3a2 2 0 1 0 0-4zm19-4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2zm13-5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3a2 2 0 0 0 2-2v-9a2 2 0 0 0-2-2zM29.5 33a1.5 1.5 0 0 1 1.5-1.5h12a1.5 1.5 0 0 1 0 3H31a1.5 1.5 0 0 1-1.5-1.5m1.5 4.5a1.5 1.5 0 0 0 0 3h14a1.5 1.5 0 0 0 0-3z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C9BF1",
    d: "M25 37.5a9.5 9.5 0 0 0-9.5-9.5v9.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4CFFF",
    d: "M8.782 44.218A9.5 9.5 0 0 0 25 37.5h-9.5z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 6,
    x: 17,
    y: 54,
    fill: "#fff",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 4,
    x: 6,
    y: 56,
    fill: "#B4CFFF",
    rx: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 10,
    x: 27,
    y: 50,
    fill: "#B4CFFF",
    rx: 2
  })));
};
export default SvgReports;